export const getNumericValue = (value: string): number => parseFloat(value.replace(/\D/g, ''));